import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/store'

Vue.use(VueRouter);

import Login from '@/components/Login/Login'
import Home from '@/components/Home/Home'
import Overview from '@/components/Overview/Overview'
import Challenges from '@/components/Challenges/Challenges'
// import ChallengeHome from '@/components/Challenges/ChallengeHome/ChallengeHome'
// import ChallengeCreate from '@/components/Challenges/ChallengeCreate/ChallengeCreate'
// import ChallengeDetail from '@/components/Challenges/ChallengeDetail/ChallengeDetail'
import Market from '@/components/Market/Market'
import Brand from '@/components/Brand/Brand'
import Vendors from '@/components/Vendors/Vendors'
import Management from '@/components/Management/Management'
import Users from '@/components/Users/Users'
import Setting from '@/components/Setting/Setting'
import NotFound from '@/components/NotFound/NotFound'
import Orders from "@/components/Orders/Orders";
import Store from "@/components/Store/Store";
import Music from "@/components/Music/Music";

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {title: 'Gbozo Dashboard'},
      children: [
        {
          path: '/overview', alias: '', name: 'overview', component: Overview, meta: {title: 'Overview'}
        }, {
          path: '/challenges', name: 'challenges', component: Challenges, meta: {title: 'Challenges'},
        }, {
          path: '/brand', name: 'brand', component: Brand, meta: {title: 'X-Brand'}
        },{
          path: '/market', name: 'market', component: Market, meta: {title: 'ZoMarket'}
        }, {
          path: '/orders', name: 'orders', component: Orders, meta: {title: 'Orders'}
        }, {
          path: '/vendors', name: 'vendors', component: Vendors, meta: {title: 'Vendors'}
        }, {
          path: '/users', name: 'users', component: Users, meta: {title: 'Users'}
        },{
          path: '/management', name: 'management', component: Management, meta: {title: 'Management'}
        }, {
          path: '/setting', name: 'setting', component: Setting, meta: {title: 'Setting'}
        },{
          path: '/music', name: 'music', component: Music, meta: {title: 'Music'}
        },{
          path: '/store', name: 'store', component: Store, meta: {title: 'Store'}
        },
      ]
    }, {
      path: '/login', name: 'login', component: Login, meta: {title: 'Login'}
    },
    {
      path: '*', name: 'notfound', component: NotFound, meta: {title: '404 NotFound'}
    }
  ]
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token');
  store.commit('setToken', token);
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (!token && to.path !== '/login') {
    next('/login')
  } else {
    next()
  }
});

export default router